module.exports = __webpack_public_path__ + "images/emoji/japanese_goblin.15bfa51abd4cac6f6131.png";